import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ServiceCategoryModel } from 'projects/Administration/src/app/business-entities/service-category';
import { ServiceCategoriesBusinessService } from 'projects/Administration/src/app/business-services/service-categories-business.service';
import { ImageService } from 'projects/Administration/src/app/services/image.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Constant } from './../../../../../../../Autofacets-Core/src/app/utils/constant';
import * as Enums from './../../../../../../../Autofacets-Core/src/app/utils/enums';
@Component({
  selector: 'app-edit-service-category',
  templateUrl: './edit-service-category.component.html',
  styleUrls: ['./edit-service-category.component.css']
})
export class EditServiceCategoryComponent implements OnInit {

  serviceCategory: ServiceCategoryModel;
  id: number;
  editServiceCategories = false;
  editServiceCategoriesForm: FormGroup;
  image: string | ArrayBuffer;
  Language: any[];
  imageBaseData: string | ArrayBuffer = null;


  constructor(private route: ActivatedRoute, private formBuilder: FormBuilder,
    private serviceCategoriesService: ServiceCategoriesBusinessService,
    private router: Router,private cdRef : ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService, private currentLanguageService: CurrentLanguage,
    private translate: TranslateService, private activeModal : NgbActiveModal,
    private imageService:ImageService) { }

  ngOnInit(): void {
    this.Language = this.currentLanguageService.LanguageList;
    this.id = this.serviceCategoriesService.serviceCategoryId
    if (this.id) {
      this.getServiceCategory();
    }
    this.editServiceCategoriesForm = this.formBuilder.group({
      service: new FormArray([]),
      Image: [''],
      ImageBinaryData: [''],
      MimeType: [''],
      OrderNumber:[null]
    });
    this.getLanguage();
  }
  get cpf() {
    return this.editServiceCategoriesForm.controls;
  }

  get t() { return this.cpf.service as FormArray; }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
        for (let i = this.t.length; i < number; i++) {
            this.t.push(this.formBuilder.group({
                languageId: ['',Validators.required],
                name: ['', Validators.required],
            }));
        }
    } else {
        for (let i = this.t.length; i >= number; i--) {
            this.t.removeAt(i);
        }
    }
}

  getServiceCategory() {
    this.spinner.show();
    this.serviceCategoriesService.getByIdServiceCategories(this.id).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.serviceCategory = response.responseObject;
        this.image=this.serviceCategory.serviceCategoriesDetails[0].logo;
        this.editServiceCategoriesForm.controls["Image"].setValue(this.serviceCategory.serviceCategoriesDetails[0].logoPath);
        this.editServiceCategoriesForm.controls["OrderNumber"].setValue(this.serviceCategory.serviceCategoriesDetails[0].orderNumber);
        this.editServiceCategoriesForm.patchValue({response})
        this.cdRef.detectChanges();
        this.spinner.hide();
      }
      else if(response.responseObject && response.responseObject.errorCount > 0)
      {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.ServicecategoriesNotFound) {
          let errormsg = this.translate.instant("lblServiceCategoryNotFound");
          this.toastr.error(errormsg);
          this.spinner.hide();
      }
    }
      this.spinner.hide();
    });
  }

  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.editServiceCategoriesForm.controls["MimeType"].setValue(files[0].type);
    this.editServiceCategoriesForm.controls["Image"].setValue(files[0].name);
    let imageSize = files[0].size;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormat=this.imageService.validateImageFormat(this.editServiceCategoriesForm.value.MimeType);
    if(isValidFormat)
    {
      if(imageSize < 100000)
      {
       reader.onload = (_readerEvent) => {
        this.serviceCategory.serviceCategoriesDetails[0].logo = "";
        me.imageBaseData = reader.result;
        this.editServiceCategoriesForm.value.ImageBinaryData=reader.result.toString().replace('data:' + this.editServiceCategoriesForm.value.MimeType + ';base64,', '');
        this.image = me.imageBaseData;
        };
      }
      else
      {
        let errormsg = this.translate.instant("lblSizeExceedError");
        this.toastr.error(errormsg);
      }
     }
    reader.onerror = function (_error) {
       // This is intentional
    };

  }

  RemoveLogo(){
    this.editServiceCategoriesForm.value.Image = "";
    this.editServiceCategoriesForm.value.ImageBinaryData = "";
    this.serviceCategory.serviceCategoriesDetails[0].logo = "";
    this.image = "";
  }

  onSubmit() {
    this.spinner.show();
       let viewModal = {
         LanguageDetails: this.editServiceCategoriesForm.value.service,
         Image: this.editServiceCategoriesForm.value.Image ? this.editServiceCategoriesForm.value.Image : "",
         ImageBinaryData: this.editServiceCategoriesForm.value.ImageBinaryData ? this.editServiceCategoriesForm.value.ImageBinaryData : "",
         MimeType: this.editServiceCategoriesForm.value.MimeType ? this.editServiceCategoriesForm.value.MimeType : "",
         OrderNumber: this.editServiceCategoriesForm.value.OrderNumber,
         Id: this.serviceCategory.serviceCategoriesDetails[0].id,
       }
    this.serviceCategoriesService.addUpdateServiceCategories(viewModal).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        let successmsg = this.translate.instant("lblServiceCategoryEdited");
        this.toastr.success(successmsg);
        this.spinner.hide();
        this.activeModal.close({ success: true });
      }
      if(response.responseObject === false)
      {
        let errormsg = this.translate.instant("lblServiceCategoryAlreadyAdded");
        this.toastr.warning(errormsg)
      }
      this.spinner.hide();
    })
  }
  OnClose(){
    this.activeModal.close({success:false})
  }
}
